<template>
  <el-dialog
    title="完成任务"
    top="0px"
    :visible.sync="dialogVisible"
    width="900px"
    center
    v-loading="loading"
    append-to-body
    @close="empty"
  >
    <el-form>
      <div class="myCompleteTip">
        <el-row>
          <el-col :span="12">
            <el-form-item label="任务名称" label-width="90px">
              <span>{{curTask.TASKNAME}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建人" label-width="90px">
              <span>{{curTask.CREATEUSERNAME}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="实际工作量" label-width="90px">
              <div class="timeDiv">
                <el-input-number v-model="actualValue" :min="1" :max="1000" class="timeInput"></el-input-number>
                <el-select v-model="actualUnit" placeholder="请选择" class="timeSelector">
                  <el-option
                    v-for="item in timeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="故障类型" label-width="80px" class="rightPadding">
              <ayb-selectMaintenance>
                :idArray="faultTypeIdArray"
                @getValue="mtGetValue"
                ref="faultTypeSelect"
              ></ayb-selectMaintenance>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="选择运维对象:" label-width="100px" class="rightPadding">
              <ayb-DeviceObjectList
                ref="DeviceObjectList"
                @getValue="getTaskSelectedInstance"
                :taskType="curTask.TASKTYPE"
                :isCuoZuo="false"
              ></ayb-DeviceObjectList>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!--   总结报告   -->
      <summaryTaskTextbox
        ref="summaryTaskTextbox"
        @getValue="summaryTaskTextbox"
        @SAVEKMS="SAVEKMS"
        @upFile="upFile"
      ></summaryTaskTextbox>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDelay">取 消</el-button>
      <el-button type="primary" @click="saveDialog">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import wangeditor from "@/components/common/editor.vue";
import summaryTaskTextbox from "./summaryTaskTextbox.vue";
import { completeTask, getEventByEventId } from "@/api/modules/basicData/task";
import { getToken } from "../../../util/auth";
const cookieUser = getToken();
export default {
  name: "CompleteTask",
  components: {
    wangeditor,
    summaryTaskTextbox,
    
  },
  props: {
    serverCenterIds: String
  },
  computed: {
    curTask: function() {
      return this.$store.state.task.curTask;
    }
  },
  watch: {
    pageSize() {
      this.SearchKnowledge();
    },
    currentPage() {
      this.SearchKnowledge();
    }
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      faultTypeIdArray: [], //故障类型赋值
      detail: {},
      myRowData: {
        userId: "",
        taskId: "",
        taskState: 2
      },
      timeOptions: [
        {
          label: "小时",
          value: 0
        },
        {
          label: "天",
          value: 1
        }
      ],
      winningEffectOptions: [
        {
          label: "高",
          value: 1
        },
        {
          label: "中",
          value: 2
        },
        {
          label: "低",
          value: 3
        },
        {
          label: "最低",
          value: 4
        }
      ],
      winningEmergenceOptions: [
        {
          label: "危急",
          value: 1
        },
        {
          label: "紧急",
          value: 2
        },
        {
          label: "一般",
          value: 3
        },
        {
          label: "最低",
          value: 4
        }
      ],
      faultTypeOptions: JSON.parse(localStorage.getItem("faultTypeOptions")), //故障类型
      winningReasonOptions: [
        {
          label: "程序Bug",
          value: 0
        },
        {
          label: "客户误操作",
          value: 1
        },
        {
          label: "产品功能缺失",
          value: 2
        },
        {
          label: "系统设置",
          value: 3
        },
        {
          label: "流程改造",
          value: 4
        },
        {
          label: "其他",
          value: 5
        }
      ], //原因分类
      winningEventTypeOptions: [], //事件类型
      needSaveSummary: false,
      actualValue: 1, //实际工作量
      actualUnit: 0, //实际工作量单位
      faultTypeList: [], //故障类型
      FaultType: [],
      otherSystemCode: "", //外部工号
      reasonType: "", //原因分类
      eventType: "", //事件分类
      effectDegree: "", //影响程度
      emergencyDegree: "", //紧急程度
      reasonInfo: "", //原因分析
      solutionInfo: "", //解决方案
      DeviceList: [],
      needReply: false,
      IsSaveKnowledge: false, //
      FilePathList: [] // 上传
    };
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
      this.needReply = this.curTask.NEEDREPLY;
      getEventByEventId(this.curTask.ID).then(pmevent => {
        if (!pmevent) this.FaultType = [];
        else {
          if (pmevent.FaultTypeList.length > 0)
            this.FaultType = [pmevent.FaultTypeList[0].FAULTTYPE];
          else this.FaultType = [];
        }
        console.log("任务类型", this.FaultType);
      });
    },
    empty() {
      this.$refs.faultTypeSelect.reset();
      this.onClear()
    },
    // 总结内容-------------
    mtGetValue(value) {
      this.faultTypeList = [];
      if (value) {
        this.faultTypeList.push(value);
      }
      console.log("故障类型", value);
    },
    // 确认
    saveDialog() {
      if (
        this.needReply &&
        (!this.completeMemo ||
          this.completeMemo.replace(/<p><br><\/p>/g, "").length == 0)
      ) {
        this.$message.warning("请输入完成备注");
        return;
      }
      this.loading = true;
      if (this.faultTypeList && this.faultTypeList.length > 0) {
        // 设备。
        this.faultTypeList.forEach(c => {
          c.TASKID = this.curTask.ID;
          c.FAULTTYPE = c.ID;
          // c.ID = 0
        });
        this.faultTypeList.forEach(c => {
          c.ID = 0;
        });
        console.log("faultTypeList", this.faultTypeList);
        let list = this.faultTypeList.map(item => {
          return {
            ID: item.ID,
            TASKID: item.TASKID,
            FAULTTYPE: item.FAULTTYPE
          };
        });
        this.faultTypeList = list;
      }
      let task = {
        TaskId: this.curTask.ID,
        ServerId: this.serverCenterIds,
        CompleteMemo: this.completeMemo,
        workloadValue: this.actualValue,
        workloadUnit: this.actualUnit,
        FaultTypeList: this.faultTypeList,
        DeviceList: this.DeviceList,
        IsSaveKnowledge: this.IsSaveKnowledge
      };
      let user = {
        ID: cookieUser.userId,
        NAME: cookieUser.realName,
        DEPTID: cookieUser.departmentId,
        DEPTNAME: cookieUser.departmentName
      };
      let FilePathList = this.$refs.summaryTaskTextbox.filePathList;// this.FilePathList;
      console.log("确认完结", task, user, FilePathList);
      completeTask(task, user, FilePathList)
        .then(result => {
          this.loading = false;
          console.log("完成任务成功", result.ResultCode);
          if (result.ResultCode <= 0) {
            this.$message.error(result.MsgInfo);
          } else {
            //总结任务
            this.dialogVisible = false;
            this.$emit("completeTaskResult");
          }
          this.onClear();
        })
        .catch(ex => {
          this.dialogVisible = false;
          this.loading = false;
          this.$logError(ex);
        });
    },
    closeDelay() {
      this.dialogVisible = false;
      this.onClear();
    },
    // 清空
    onClear() {
      this.actualValue = 1; //实际工作量
      this.actualUnit = 0; //实际工作量单位
      this.otherSystemCode = ""; //外部工号
      this.reasonType = ""; //原因分类
      this.eventType = ""; //事件分类
      this.effectDegree = ""; //影响程度
      this.emergencyDegree = ""; //紧急程度
      this.reasonInfo = ""; //原因分析
      this.solutionInfo = ""; //解决方案
      this.$refs.summaryTaskTextbox.onClear = 1;
      this.$refs.DeviceObjectList.selectedObject = [];
    },
    // 运维对象实例
    getTaskSelectedInstance(data, sourceData) {
      this.DeviceList = [];
      console.log("getTaskSelectedInstance", data, sourceData, this.curTask.ID);
      let TASKID = this.curTask.ID;
      sourceData.filter(res => {
        let DeviceList = {};
        DeviceList.TASKID = TASKID;
        DeviceList.NAME = res.Name;
        DeviceList.SOCIALID = res.SocialId;
        DeviceList.OBJTYPENAME = res.ObjectTypeName;
        DeviceList.SOCIALTYPE = res.Type;
        DeviceList.BRANDCODE = res.BrandCode;
        DeviceList.BRANDSHOWNAME = res.BrandName;
        DeviceList.SERIAL = res.Serial;
        DeviceList.MODE = res.Model;
        DeviceList.LOCATION = res.Area;
        DeviceList.OBJTYPE = res.ObjectType;
        this.DeviceList.push(DeviceList);
      });
      // this.DeviceList.push(DeviceList)
      console.log("DeviceList", this.DeviceList);
    },
    // 总结报告
    summaryTaskTextbox(val) {
      console.log("总结报告", val);
      this.completeMemo = val;
    },
    SAVEKMS(val) {
      //知识库
      console.log("知识库", val);
      this.IsSaveKnowledge = val;
    },
    upFile(val) {
      this.FilePathList = val;
    }
  }
};
</script>

<style scoped>
.timeInput {
  display: inline-block;
  width: 50%;
  margin-right: 3px;
  margin-left: 3px;
  margin-top: 1px;
}
.timeSelector {
  display: inline-block;
  width: 40%;
}
.timeDiv {
  display: flex;
}
.faultTypeSelector {
  float: left;
}
span {
  float: left;
}
.el-form-item {
  margin-bottom: 5px;
}
.rightPadding {
  box-sizing: border-box;
  padding-right: 20px;
}
</style>
